module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0088.jpg?v=f5b37d8a";